import React from "react";
import { getDaysUntil } from '../../../utils/daysUntil'
import { formatDate } from '../../../utils/formatDate'
import formatCurrency from "../../../utils/formatCurrency"
import { useIsMobile } from '../../../utils/hooks'
import { Receivable } from '../../../api/types'


const ReceivableCard: React.FC<{ data: Receivable }> = ({ data: { amount, customer, expectedDate, status }
}) => {
    const icon = (
        <div
            className={`bg-gray-800 shadow flex rounded-full aspect-square w-11 shrink-0 items-center justify-center`}
        >
            <span className={`font-medium text-white text-2xl`}>
                {customer[0]}
            </span>
        </div>
    );

    const formattedAmount = formatCurrency(amount)
    const formattedDate = formatDate(expectedDate);
    const isMobile = useIsMobile()

    return (
        <div className="gap-2 p-2 font-medium hover:bg-gray-100 cursor-pointer text-base grid grid-cols-[2fr_1fr_1fr_1fr_1fr] gap-6 items-center bg-white w-full rounded-md">

            {/* Title and Details */}
            <div className="flex gap-2 items-center">
                {icon}
                <div className="flex flex-col">
                    <div className="text-gray-800 font-semibold">{customer}</div>
                    <div className="flex flex-wrap items-center text-sm text-gray-500 gap-1">
                        <span>{formattedDate} ● </span>
                        <span>-</span>
                    </div>
                </div>
            </div>

            {/* Status */}
            <div
                className={`tag-1 w-fit`}
            >
                {status}
            </div>

            {/* Amount */}
            <div className="text-gray-800 whitespace-nowrap">
                {formattedAmount}
            </div>

            {/* Account */}
            <div className="text-gray-600 whitespace-nowrap">
                -
            </div>

            {/* Due in */}
            <div className="text-gray-800 whitespace-nowrap">
                {getDaysUntil(expectedDate)} days
            </div>

        </div>
    )
};

export default ReceivableCard;
